

export const localState = {
    setLocalState: (name:string, value:any) => {
        localStorage.setItem('@DommusCRM-'+name, value);
    },
    getLocalState: (name:string) => {
        const value = localStorage.getItem('@DommusCRM-' + name);
        return value;
    }
}